import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	selectCurrentPage,
	selectCurrentSubTitle,
	selectSidePanelTitle,
	getUserTypeAndPermissions,
	//setUserCredentials,
	selectUserType,
	selectUserId,
	selectUserName,
	setCurrentPage,
	selectLoadingState,
	selectNavState,
	selectPages,
	putUser,
	selectSidePanelOptions,
	setSidePanelTitle,
	selectCredentials,
	//setHomeAccountId,
	selectUserStatusLoading,
	putUserStatus,
	signOut
} from '../../store/pageLayoutSlice';
import {
	getCustomerInfo,
	selectIsQuoteRevision,
	getCategories,
	clearStateValues,
	getDiscounts,
	selectDiscounts,
	selectLoadingStatus,
	getAllNotifications,
	selectNotifications,
	setActiveNotificationInfo,
	filterQuoteObjectsByInputDate
} from '../../store/quotesAndNotificationsSlice';
import { getUserTypes } from '../../store/delegationOfAuthoritySlice';
import './PageLayout.css';
import Select from '../../components/Select/Select';
import Loader from "../../components/Loader/Loader";
import NavBar from "../../components/NavBar/NavBar";
import SidePanel from '../../components/SidePanel/SidePanel';
import CreateQuote, { CreateQuoteSPC } from '../CreateQuote/CreateQuote';
import AdminPortal, { AdminPortalSPC } from '../AdminPortal/AdminPortal';
import Notifications, { NotificationsSPC } from '../Notifications/Notifications';
import Quotes, { QuotesSPC } from '../Quotes/Quotes';
import { signoutIcon } from '../../assets/Icons/Icons';
import { apiCall } from '../../APICalls/APICalls';

function getCurrentContent(currentPage){
	let mainContent, sidePanelContent;
	switch( currentPage ){

		case "Create Quote":
			mainContent = <CreateQuote />;
			sidePanelContent = <CreateQuoteSPC />;
		break;
		case "Notifications":
			mainContent = <Notifications />;
			sidePanelContent = <NotificationsSPC />;
		break;
		case "Quotes":
			mainContent = <Quotes />;
			sidePanelContent = <QuotesSPC />;
		break;
		case "Admin Portal":
			mainContent = <AdminPortal />;
			sidePanelContent = <AdminPortalSPC />;
		break;
		// no default
	}
	return {
		mainContent: mainContent,
		sidePanelContent: sidePanelContent
	};
}

function PageLayout(props){

	const dispatch = useDispatch();
	const userAccessPages = useSelector( selectPages );
	const navState = useSelector( selectNavState );
	let currentPage = useSelector( selectCurrentPage );
	const isQuoteRevision = useSelector( selectIsQuoteRevision );
	const currentSubTitle = useSelector( selectCurrentSubTitle );
	const sidePanelTitle = useSelector( selectSidePanelTitle );
	const { mainContent, sidePanelContent } = getCurrentContent(currentPage);
	const { userType, permissions } = useSelector( selectUserType );
	const userId = useSelector( selectUserId );
	const userName = useSelector( selectUserName );
	const loadingState = useSelector( selectLoadingState );
	const { userStatus } = useSelector( selectCredentials );
	const sidePanelOptions = useSelector( selectSidePanelOptions );
	const discounts =  useSelector( selectDiscounts );
	const customerInfoLoading = useSelector( selectLoadingStatus ).customerInfo;
	const notifications = useSelector( selectNotifications );
	const notificationsLoading = useSelector( selectLoadingStatus ).notifications;

	const [tokenProcessed, setTokenProcessed] = useState(false);
	const [hasToken, setHasToken] = useState(false);

	function setSidePanel(e){
		dispatch( setSidePanelTitle(e.target.textContent) );
	}

	if( currentPage === "Create Quote" && isQuoteRevision ){
		currentPage += " (Revision)";
	}

	// Check for token on mount and set page to Notifications if it exists
	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get('token');

		if (token) {
			setHasToken(true);
			// Set page to Notifications immediately when token is detected
			dispatch(setCurrentPage('Notifications'));
		}
	}, [dispatch]);

	useEffect(() => {

		dispatch( getUserTypeAndPermissions({ app: "hdmi", userId: userId }) );

	}, [ dispatch, userId ]);

	// Process token and select specific notification once notifications are loaded
	useEffect(() => {
		if (hasToken && !tokenProcessed && notifications.length > 0 && notificationsLoading === 'complete') {
			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get('token');

			if (token) {
				try {
					// Decode the base64 token
					const decoded = JSON.parse(atob(token));
					const { quoteId, notificationId } = decoded;

					// Find the quote and notification in the loaded data
					const quote = notifications.find(q => q.quoteId === quoteId);

					if (quote) {
						const notification = quote.quote[0].notifications?.find(
							n => n.notificationId === notificationId
						);

						if (notification) {
							// Set the active notification
							const notificationInfo = {
								quoteId: quoteId,
								revisionNumber: quote.quote[0].revisionNumber,
								notificationId: notificationId
							};
							dispatch(setActiveNotificationInfo(notificationInfo));

							// Mark notification as read if it's currently unread (same pattern as handleNotificationClick)
							if (notification.status.toLowerCase() === 'unread') {
								apiCall('quotesAndNotifications/getSingleQuote', { quoteId: quoteId }).then(res => {
									const notifiedQuote = filterQuoteObjectsByInputDate(res.data)[0];
									if (notifiedQuote) {
										const revisionIndex = notifiedQuote.quote.findIndex(
											revision => revision.revisionNumber === quote.quote[0].revisionNumber
										);
										if (revisionIndex !== -1) {
											const notificationIndex = notifiedQuote.quote[revisionIndex].notifications.findIndex(
												note => note.notificationId === notificationId
											);
											if (notificationIndex !== -1) {
												notifiedQuote.quote[revisionIndex].notifications[notificationIndex].status = 'Read';
												apiCall('quotesAndNotifications/putQuote', notifiedQuote).then(res => {
													console.log('Notification marked as read from email link');
												}).catch(e => console.log(e));
											}
										}
									}
								}).catch(e => console.log(e));
							}

							console.log('Navigated to notification from email link:', notificationInfo);
						} else {
							console.log('Notification not found:', { quoteId, notificationId });
						}
					} else {
						console.log('Quote not found:', quoteId);
					}

					// Remove token from URL
					urlParams.delete('token');
					const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
					window.history.replaceState({}, '', newUrl);

				} catch (error) {
					console.error('Error processing token:', error);
				}

				setTokenProcessed(true);
			}
		}
	}, [dispatch, hasToken, notifications, notificationsLoading, tokenProcessed]);

	useEffect(() => {
		if( userType ){
			if( userType === "N/A"){
					// A signed-in account with no user type. Nothing to do
					// here: the slice puts the user on the Pending page and an
					// administrator assigns them a type.
					//
					// This used to self-register - fetch the whole Pending user
					// type document, append itself to activeUsers and write the
					// document back. That only made sense when anyone in the
					// tenant could arrive unannounced via SSO. Accounts are now
					// provisioned deliberately, by the seed migration or by an
					// administrator, so a user arriving here is a data problem
					// rather than a new joiner.
					//
					// It also meant any authenticated user could rewrite the
					// document that defines everyone's permissions, so the
					// endpoint now requires an Admin Portal permission and this
					// call would be refused regardless.
			} else if( userType === "Admin" ){
				dispatch( getCustomerInfo() ).unwrap().then( res => {
					dispatch( getUserTypes({app: "hdmi"}) );
					dispatch( getCategories({ app: "hdmi" }) );
				}).catch(err => {
					dispatch( getUserTypes({app: "hdmi"}) );
					dispatch( getCategories({ app: "hdmi" }) );
				});
			} else {
				if( userType !== "Pending" ){
					dispatch( getCustomerInfo() ).unwrap().then( res => {
						dispatch( getCategories({ app: "hdmi" }) );
					}).catch(err => {
						dispatch( getCategories({ app: "hdmi" }) );
					});
				}
			}
		}

	}, [ dispatch, userType ]);

	// useEffect(() =>{
	// 	if( discounts.length === 0 && ( permissions.includes('Create Quote') || permissions.includes('Create Quote Revision') ) ){
	// 		dispatch( getDiscounts() );
	// 	}
	// }, [ dispatch, permissions ]);

	return (
		<div id="page_layout_wrapper">
			<div id="page_header_wrapper">
				<div id="page_title_wrapper">
					<h1 id="page_title">{ currentPage }</h1>
					<h4 id="sub_title">{ currentSubTitle }</h4>
				</div>
				<div id="gf_logo_wrapper">
					<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 35 133 45">
						<title>gf</title>
						<polygon className="cls-1" points="0 60.96 9 61 9 70 17 70 17 61 26 61 26 53 17 53 17 44 9 44 9 53 0 53.09 0 60.96"/>
						<polygon className="cls-1" points="107 60.96 116 61 116 70 124 70 124 61 133 61 133 53 124 53 124 44 116 44 116 53 107 53.09 107 60.96"/>
						<path className="cls-1" d="M69.6,45.64l-7.14,4.14c-.22-.3-.72-.89-1.48-1.76a12.89,12.89,0,0,0-9.2-3.52,11.64,11.64,0,0,0-7.71,2.73q-4.27,3.57-4.28,10.1A14.19,14.19,0,0,0,42,65.5a11.39,11.39,0,0,0,10,5.23q5.84,0,8.91-4a22,22,0,0,0,1.72-3H51.9V56.25l20.22.06q0,8.85-3.94,14.24-5.84,8-16.51,8A24.6,24.6,0,0,1,46.76,78a18.45,18.45,0,0,1-12-7.95,21.44,21.44,0,0,1-3.6-12.48,23.81,23.81,0,0,1,.57-5.51A20.78,20.78,0,0,1,36.36,43a18.82,18.82,0,0,1,3-2.66A20.53,20.53,0,0,1,51.9,36.5,21.56,21.56,0,0,1,64.06,40a20.16,20.16,0,0,1,3.66,3.12A19.59,19.59,0,0,1,69.6,45.64Z"/>
						<polygon className="cls-1" points="77.54 37.47 100.96 37.47 100.96 45.07 86.34 45.07 86.34 53 101 53 101 61 86.34 61 86.34 77.53 77.54 77.53 77.54 37.47"/>
					</svg>
				</div>
			</div>
			{
				(userType !== 'N/A' && userType !== 'Pending' && userStatus.toLowerCase() !== 'deactivated' && loadingState !== 'rejected') && 
				<div id="page_layout">
					<NavBar userPages={ userAccessPages } navState={ navState } />
					<div id="main_content">
						{ mainContent }
					</div>
					<SidePanel title={ sidePanelTitle } options={ sidePanelOptions } setSidePanel={ setSidePanel } >
						{ sidePanelContent }
					</SidePanel>
				</div>
			}
			{
				((userType === 'N/A' || userType === 'Pending') && userStatus.toLowerCase() !== 'deactivated') &&
				<div>
					<h2 id="new_account_message">An account has been created for you and is currently pending admin approval.</h2>
				</div>
			}
			{
				(userStatus.toLowerCase() === 'deactivated') &&
				<div>
					<h2 id="new_account_message">Your account has been deactivated. Please contact an admin if you think this was a mistake.</h2>
				</div>
			}
			{
				loadingState === 'rejected' &&
				<div>
					<h2 id="new_account_message">There was a problem logging into the application.</h2>
				</div>
			}
			{ (loadingState === 'loading' || customerInfoLoading === 'loading') && <Loader /> }
		</div>
	);
}

function AccountInfoSP(props){
	const dispatch = useDispatch();
	useEffect(()=>{
		dispatch( setSidePanelTitle('Account') );
	}, [ dispatch ]);

	const credentials = useSelector( selectCredentials );

	const loading = useSelector( selectUserStatusLoading );

	const {
		userName,
		userStatus,
		userId
	} = credentials;

	const {
		userType,
		role
	} = credentials.userType;

	const colorsArray = [
        '#33adff',
        '#ff6600',
        '#007a3d',
        '#213943',
        '#c7e0f4'
    ];

	const [ editStatus, setEditStatus ] = useState(false);
	const [ status, setStatus ] = useState(userStatus);
	const [ circleFill, setCircleFill ] = useState( colorsArray[ Math.floor( Math.random() * ( colorsArray.length ) ) ] );

	function handleStatusChange(){
		setEditStatus(false);
		if( status !== userStatus ){
			const userData = {
				app: "hdmi",
				userId: userId,
				userType: userType,
				role: role,
				status: status
			};
			dispatch( putUserStatus( userData ) );
		}
	}

	function handleSignOut(){
		// A reload used to be enough when "signed in" was just a flag in
		// Redux. The session is now a server-side record, so it has to be
		// ended there; otherwise the cookie stays valid and the next page
		// load signs the user straight back in.
		dispatch( clearStateValues() );
		dispatch( signOut() );
	}

	useEffect(() => {
		setStatus( userStatus );
	}, [ userStatus ]);

	const initials = userName.match( /\b(\w)/g ).join('').slice(0, 2).toUpperCase();

	return (
		<div className="account_sp_wrapper">
			<div className="account_sp_name_container">
				<svg height="32" width="32">
					<circle cx="16" cy="16" r="16" fill={ circleFill } />
					<text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fontWeight="600" fill="white">{initials}</text>
				</svg>
				<p className="account_sp_name">
					{ userName }
				</p>
			</div>
			<p className="account_sp_text">
				<span className="account_sp_label">User Type:</span> { userType }
			</p>
			<p className="account_sp_text">
				<span className="account_sp_label">Role:</span> { role.replace(/(^\w|\s\w)/g, r => r.toUpperCase()) }
			</p>
			<div className="account_sp_status_container">
				{	
					!editStatus &&
					<>
						<p className="account_sp_text">
							<span className="account_sp_label">Status:</span> { userStatus }
						</p>
						{/* <button
							className="account_status_edit_button"
							onClick={ () => setEditStatus(true) }
						>Edit</button> */}
					</>
				}
				{
					editStatus && 
					<>
						<div className="account_sp_status_select_container">
							<label className="account_sp_label">Status:</label>
							<Select 
								value={ status }
								handleChange={ (e) => setStatus(e.target.value) }
								placeHolder="Select a status"
								options={ ['Available', 'Away'] }
								selectClass="account_sp_status_select"
							/>
						</div>
						<button
							className="account_status_edit_button"
							onClick={ handleStatusChange }
						>Save</button>
					</>
				}
			</div>
			<div className="account_sp_signout_container">
				<button
					className="signout_button"
					//onClick={ () => signOutClickHandler(instance, homeAccountId) }
					onClick={ handleSignOut }
				>
					{ signoutIcon }
					Sign Out
				</button>
			</div>
			{
				loading === 'loading' &&
				<Loader local={true} />
			}
		</div>
	);
}

export { AccountInfoSP };
export default PageLayout;